export default __webpack_public_path__ + "static/media/closeicon.ab670c7f.svg";